<div class="modal-content">
    <div class="modal-header m-0 position-absolute end-0" style="z-index: 9999;">
        <button aria-hidden="true" aria-label="Close" 
            class="ms-auto close" type="button"><i class="material-icons-round pmd-icon-sm" (click)="hideConfirmationModal()">close</i></button>
    </div>
    <div class="modal-body text-center">
        <div class="mb-3 pmd-avatar pmd-avatar-primary pmd-avatar-xl d-inline-flex" aria-hidden="true">
            <span class="material-icons">question_mark</span>
        </div>
        <h3 id="ArchiveLabel" class="h3">You have unsaved changes
        </h3>
        <p id="ArchiveDescription">Do you want to stay with your changes or discard them?</p>
    </div>
    <!-- Modal Footer -->
    <div class="modal-footer justify-content-center mt-2">
        <button type="button" aria-label="Close" (click)="hideConfirmationModal()"
            pmdRipple pmd-btn-raised color="secondary">Stay on this Page</button>
        <button type="button" aria-label="Close" 
            pmd-btn-outline pmdRipple color="dark" (click)="hideConfirmationModal(1)">Discard</button>
    </div>
</div>
